import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import { CreateSearchBarWithPlaceHolder } from '../CommonObjects';
import {CreateTableForEmployeeSelect} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
//icons
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function AttendanceReport({user, isHideSideMenu}) {
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [companyId, setCompanyId] = useState(0);
    const [company, setCompany] = useState(null);
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);

    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const numberWithCommasAndDecimal = (number) => {
        if(!number){
            return "0.00";
        }
        return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    function base64ToUint8Array(base64String) {
        const byteCharacters = atob(base64String); // Decode Base64
        const byteNumbers = new Array(byteCharacters?.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        return new Uint8Array(byteNumbers);
    }
    const writeFont7Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 7, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }
    const writeFont9Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 9, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }

    const modifyAndDownloadPDF = useCallback(async (data) => {
        if (data?.length <= 0) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No records found");
            return;
        }

        setLoading(true);
        console.log(data)

        try {
            // Load the existing PDF template
            const pdfUrl = `${window.location.origin}/docs/Attendance-Report.pdf`;
            const response = await fetch(pdfUrl);
            const pdfBytes = await response.arrayBuffer();
            const pdfDoc = await PDFDocument.load(pdfBytes);
            const templatePdf = await PDFDocument.load(pdfBytes); // Load again for copying

            let page = pdfDoc.getPages()[0]; // Get first page
            const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
            const fontNormal = await pdfDoc.embedFont(StandardFonts.Helvetica);

            let pageCount = 1;

            writeFont7Black({ page, fontNormal, x: 385, y: 20, text: `Page ${pageCount}` });

            const _dateToday = new Date().toISOString().split("T")[0];
            const _dateFrom = dateFrom.split("T")[0];
            const _dateTo = dateTo.split("T")[0];

            //611 height

            // Embed Company Logo
            if(company?.logo){
            const companyLogoBinary = base64ToUint8Array(company.logo);
            const companyLogo = await pdfDoc.embedPng(companyLogoBinary);
            page.drawImage(companyLogo, { x: 20, y: 500, width: 200, height: 100 });
            }

            //generated date
            writeFont7Black({ page, font, x: 655, y: 570, text: `${_dateToday}` });

            //generated by
            writeFont7Black({ page, font, x: 655, y: 548, text: `${user.employeePersonalInformationFullName}` });

            writeFont9Black({ page, font, x: 390, y: 470, text: `${_dateFrom}` });
            writeFont9Black({ page, font, x: 390, y: 449, text: `${_dateTo}` });

            const startX_item_1 = 35;
            const startX_item_2 = 145;
            const startX_item_3 = 230;
            const startX_item_4 = 285;
            const startX_item_5 = 335;
            const startX_item_6 = 397;
            const startX_item_7 = 505;
            const startX_item_8 = 575;
            const startX_item_9 = 650;
            const startX_item_10 = 705;
            let startY = 370;
            const lineSpacing = 50;
            const minY = 50; // Prevents writing too low

            for (let index = 0; index < data?.length; index++) {
                const item = data[index];
            
                if (startY - lineSpacing < minY) {
                    pageCount += 1;

                    // Add new template page when out of space
                    const [templatePage] = await pdfDoc.copyPages(templatePdf, [0]);
                    page = pdfDoc.addPage(templatePage);
                    startY = 370; // Reset Y position
            
                    if(company?.logo){
                    const companyLogoBinary = base64ToUint8Array(company.logo);
                    const companyLogo = await pdfDoc.embedPng(companyLogoBinary);
                    page.drawImage(companyLogo, { x: 20, y: 500, width: 200, height: 100 });
                    }

                    //generated date
                    writeFont7Black({ page, font, x: 655, y: 570, text: `${_dateToday}` });
        
                    //generated by
                    writeFont7Black({ page, font, x: 655, y: 548, text: `${user.employeePersonalInformationFullName}` });

                    writeFont7Black({ page, fontNormal, x: 385, y: 20, text: `Page ${pageCount}` });
                    writeFont9Black({ page, font, x: 390, y: 470, text: `${_dateFrom}` });
                    writeFont9Black({ page, font, x: 390, y: 449, text: `${_dateTo}` });
                }

                let _date = "";
                let _timeIn = "";
                let _timeOut = "";

                if(item.date){
                    _date = item.date.split("T")[0]
                }
                if(item.timeIn){
                    let time = ConvertForTimeLocal(item.timeIn, "Time In");

                    let timeParts;
                    const timeSplit = time.split('T');
                    if (timeSplit?.length > 1) {
                        timeParts = timeSplit[1].substr(0, 5).split(':');
                    } else {
                        timeParts = [];
                    }
                    let hours = parseInt(timeParts[0], 10);
                    const minutes = timeParts[1];

                    // Convert 24-hour format to 12-hour format and determine AM or PM
                    const amPm = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

                    _timeIn = `${hours}:${minutes} ${amPm}`;
                }
                if(item.timeOut){
                    
                    let time = ConvertForTimeLocal(item.timeOut, "Time Out");

                    let timeParts;
                    const timeSplit = time.split('T');
                    if (timeSplit?.length > 1) {
                        timeParts = timeSplit[1].substr(0, 5).split(':');
                    } else {
                        timeParts = [];
                    }
                    let hours = parseInt(timeParts[0], 10);
                    const minutes = timeParts[1];

                    // Convert 24-hour format to 12-hour format and determine AM or PM
                    const amPm = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

                    _timeOut = `${hours}:${minutes} ${amPm}`;
                }
            
                // Write employee data
                writeFont7Black({ page, fontNormal, x: startX_item_1, y: startY, text: `${item.employeePersonalInformationEmployeeId}` });
                writeFont7Black({ page, fontNormal, x: startX_item_1, y: startY - 20, text: `${item.employeePersonalInformationFullName}` });
                writeFont7Black({ page, fontNormal, x: startX_item_2, y: startY, text: `${item.departmentDescription}` });
                writeFont7Black({ page, fontNormal, x: startX_item_3, y: startY, text: `${_date}` });
                writeFont7Black({ page, fontNormal, x: startX_item_4, y: startY, text: `${_timeIn}` });
                writeFont7Black({ page, fontNormal, x: startX_item_5, y: startY, text: `${_timeOut}` });
                writeFont7Black({ page, fontNormal, x: startX_item_6, y: startY, text: `${item.approvedLeave}` });
                writeFont7Black({ page, fontNormal, x: startX_item_6, y: startY - 20, text: `${item.leaveType}` });
                writeFont7Black({ page, fontNormal, x: startX_item_7, y: startY, text: `${item.tardy}` });
                writeFont7Black({ page, fontNormal, x: startX_item_7, y: startY - 20, text: `${numberWithCommasAndDecimal(item.tardyMinutes)}` });
                writeFont7Black({ page, fontNormal, x: startX_item_8, y: startY, text: `${item.undertime}` });
                writeFont7Black({ page, fontNormal, x: startX_item_8, y: startY - 20, text: `${numberWithCommasAndDecimal(item.undertimeMinutes)}` });
                writeFont7Black({ page, fontNormal, x: startX_item_9, y: startY, text: `${item.absent}` });
                writeFont7Black({ page, fontNormal, x: startX_item_10, y: startY, text: `${item.hoursWorked}` });
                
                writeFont7Black({ page, font, x: 35, y: startY - 30, text: `__________________________________________________________________________________________________________________________________________________________________________________________` });
            
            
                startY -= lineSpacing; // Move to next row
            }

            setShowRequestMessage(true);
            setIsSuccess(true);

            // Save and Download PDF
            const modifiedPdfBytes = await pdfDoc.save();
            const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });

            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = `Attendance-Report.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(a.href);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error("Error:", error);
            setRequestMessage("Error processing PDF");
        }

        setLoading(false);
    }, [company, user, dateFrom, dateTo]);

    const fetchDataCompany = useCallback(async () => {
        const apiUrl =  domain + `/api/Company/${companyId}`;

        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            return response.data;
        } catch (error) {
            return null
        }
    }, [companyId]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/attendance-report/employee/${employeePersonalInformationId}/dateFrom/${dateFrom}/dateTo/${dateTo}`;

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            const _company = await fetchDataCompany();
            setCompany(_company)

            modifyAndDownloadPDF(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [modifyAndDownloadPDF, fetchDataCompany, employeePersonalInformationId, dateFrom, dateTo]);

    const generate = () =>{
        if(!companyId || !dateFrom || !dateTo || !employeePersonalInformationId
        ){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        fetchData();
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Attendance Report"}</span>
                            </div>
                            <h3>Generate Attendance Report</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row">
                                <div className="info-item2 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Date From</div>
                                    <div className="info-item-input">
                                        <DateTimeInput date={dateFrom} setDate={setDateFrom}/>
                                    </div>
                                    <span style={{
                                                visibility: !dateFrom && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item2 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Date To</div>
                                    <div className="info-item-input">
                                        <DateTimeInput date={dateTo} setDate={setDateTo}/>
                                    </div>
                                    <span style={{
                                                visibility: !dateTo && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="info-item-holder row">
                                <div className="info-item2 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Employee</div>
                                    <div className="info-item-input">
                                        <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Employee"
                                                value={employeePersonalInformationId ? (employeePersonalInformationId + " - " + employeePersonalInformationFullName) : employeePersonalInformationId}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowEmployeeForm(true)}
                                            ><SearchIcon/></button>
                                        </div>
                                        <span style={{
                                                visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                    </div>
                                </div>
                                <div className="info-item2 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect companyId={companyId} setCompanyId={setCompanyId} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !companyId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row">
                                <button id="activeEmployeesGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
                    user={user}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={date}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function EmployeeSelectForm({isOpen, 
    onClose,
    user,
    setEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Employee/basic-info/all`;

        try {
            setLoading(true);
            const response = await axios.post(apiUrl , user, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [user])
    const [currentPage, setCurrentPage] = useState(1);
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex, fetchData]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees?.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function CompanyTypeSelect({companyId, setCompanyId, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        setCompanyId(selectedCompanyId);
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (companyId !== "" && companyId !== 0 && companyId !== null && companyId !== undefined && companyId?.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [companyId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={companyId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((companyId) => ( 
                SetCompanyType(companyId)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(company){
    return(
        <option value={company.id}>{
            company.name}
        </option>
    )

}
const ConvertForTimeLocal = (dateString, name) => {
    // console.log("timeString", dateString);

    if (!dateString) {
        console.log(`${name} is empty or invalid data`);
        return "";
    }

    // Split the date and time parts
    const [datePart, timePart] = dateString.split('T');

    if (!timePart) {
        console.log(`${name} does not have a valid time part`);
        return "";
    }

    // Parse the date part
    const [year, month, day] = datePart.split('-');
    
    // Parse the time part
    const [hour, minute, second] = timePart.split(':');
    let hour24 = parseInt(hour, 10);

    // Construct the Date object
    const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), hour24, parseInt(minute, 10), parseInt(second, 10));

    // Format the date string in the desired format
    const formattedDateString = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

    return formattedDateString;
};
export default AttendanceReport
